module.exports = __webpack_public_path__ + "static/media/icon-circle-light.f26a876a.svg";